import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WatchlistContextComparison from './WatchlistContextComparison';

export default function WatchlistContextDetails({
    saved, available, changedFields, availableLabel = 'This update', review, vendorSwitch,
}) {
    const [open, setOpen] = useState(false);
    if ((!saved || !available) && !review) return null;
    const affectedPortfolios = new Set((review?.portfolio_impact?.securities || [])
        .flatMap((row) => row.affected_portfolios || []));
    const actualAffected = affectedPortfolios.has('Current') || affectedPortfolios.has('Actual');
    const sizingAffected = affectedPortfolios.has('Position Sizing');
    return (
        <>
            <Tooltip title="About this Watchlist change">
                <IconButton size="small" color="inherit" aria-label="About this Watchlist change"
                    onClick={() => setOpen(true)}>
                    <InfoOutlinedIcon fontSize="small" />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth
                aria-labelledby="watchlist-update-details-title">
                <DialogTitle id="watchlist-update-details-title">About this Watchlist change</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" paragraph>
                        Different factor providers, models and datasets can support different securities.
                        {review && ' The changes shown in this review must be approved before the selected data becomes active.'}
                    </Typography>
                    {review && vendorSwitch && (
                        <Typography variant="body2" paragraph>
                            Approving applies the Watchlist changes and switches to {vendorSwitch.to} together.
                            {' Cancelling keeps '}{vendorSwitch.from} and your current Watchlist.
                        </Typography>
                    )}
                    {actualAffected && (
                        <Typography variant="body2" paragraph>
                            Applying removes the listed securities from your Watchlist and their affected Actual Portfolio positions.
                        </Typography>
                    )}
                    {sizingAffected && (
                        <Typography variant="body2" paragraph>
                            Position Sizing entries are kept. Review the draft after applying because it may be out of sync.
                        </Typography>
                    )}
                    {review && (
                        <Typography variant="body2" paragraph>
                            To use an excluded security later, choose factor data that supports it and restore or add it through Watchlist review.
                        </Typography>
                    )}
                    {saved && available && (
                        <>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>Factor data comparison</Typography>
                            <WatchlistContextComparison saved={saved} available={available}
                                changedFields={changedFields} savedLabel="Previous Watchlist"
                                availableLabel={availableLabel} />
                        </>
                    )}
                </DialogContent>
                <DialogActions><Button onClick={() => setOpen(false)}>Close details</Button></DialogActions>
            </Dialog>
        </>
    );
}
